export const locale = {
  lang: 'de',
  data: {
    MENU: {
      LOG: 'Log',
      COMPANY: 'Empresaas',
      USERS: 'Usuarios'
    }
  }
}
